import { useNode } from '@craftjs/core';
import {
    Button,
    Checkbox,
    Chip,
    FormControlLabel,
    FormGroup,
    Stack,
    Switch,
    Typography,
} from '@mui/material';
import { SettingCard } from '@/components';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse } from "date-fns";
import { useState } from 'react';
import { daysOptions } from '@/constants/days';

const CalendarSettings = () => {
    const {
        actions: { setProp },
        props,
    } = useNode((node) => ({
        props: node.data.props,
    }));

    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const handleAddDate = () => {
        if (!selectedDate) return;
        //change to farmat day, month, year

        const value = format(selectedDate, "dd/MM/yyyy");

        setProp((props: any) => {
            const dates = props.availability?.blockedDates || [];

            if (!dates.includes(value)) {
                props.availability = {
                    ...props.availability,
                    blockedDates: [...dates, value],
                };
            }
        });

        setSelectedDate(null);
    };

    const handleRemoveDate = (date: string) => {
        setProp((props: any) => {
            props.availability = {
                ...props.availability,
                blockedDates: props.availability.blockedDates.filter((d: string) => d !== date),
            };
        });
    };

    return (
        <Stack spacing={2}>
            <SettingCard title="Calendario">
                <Stack spacing={2}>
                    {/* Disable Past */}
                    <FormControlLabel
                        control={
                            <Switch
                                checked={props.disablePast || false}
                                onChange={(e) =>
                                    setProp((props: any) => {
                                        props.disablePast = e.target.checked;
                                    })
                                }
                            />
                        }
                        label="Deshabilitar fechas pasadas"
                    />

                    {/* Allowed Days */}
                    <Typography variant='h4' fontSize={16}>Días disponibles</Typography>
                    <FormGroup row>
                        {daysOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                control={
                                    <Checkbox
                                        checked={
                                            props.availability?.weekDays?.includes(option.value) || false
                                        }
                                        onChange={(e) =>
                                            setProp((props: any) => {
                                                const current = props.availability?.weekDays || [];

                                                props.availability = {
                                                    ...props.availability,
                                                    weekDays: e.target.checked
                                                        ? [...current, option.value]
                                                        : current.filter((v: number) => v !== option.value),
                                                };
                                            })
                                        }
                                    />
                                }
                                label={option.label}
                            />
                        ))}
                    </FormGroup>

                    {/* Disabled Dates */}
                    <Stack spacing={2}>
                        <Typography variant="h4">Agregar fechas bloqueadas</Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Seleccionar fecha"
                                value={selectedDate}
                                format={"dd/MM/yyyy"}
                                onChange={setSelectedDate}
                                sx={{
                                    backgroundColor: "white",

                                }}
                            />
                        </LocalizationProvider>

                        <Button
                            variant="contained"
                            onClick={handleAddDate}
                            disabled={!selectedDate}
                        >
                            Agregar fecha
                        </Button>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                            {(props.availability?.blockedDates || []).map((date: string) => (
                                <Chip
                                    key={date}
                                    label={format(
                                        parse(date, "yyyy-MM-dd", new Date()),
                                        "dd/MM/yyyy"
                                    )}
                                    onDelete={() => handleRemoveDate(date)}
                                    color="primary"
                                />
                            ))}
                        </Stack>
                    </Stack>

                </Stack>
            </SettingCard>
        </Stack>
    );
};

export default CalendarSettings;
